import React, { FC } from "react";
import { Link, useLocation } from "react-router-dom";

import {
  Badge,
  ListItem,
  ListItemIcon,
  ListItemText,
  SvgIconProps,
} from "@mui/material";

export const SidebarItem: FC<{
  icon?: FC<SvgIconProps>;
  label?: string;
  toggle: () => void;
  path: string;
  leftSpace?: number;
  group?: number;
  role?: number;
  badgeContent?: number;
}> = ({
  path,
  icon: Icon,
  label = "",
  toggle,
  leftSpace = 0,
  badgeContent,
}) => {
  const location = useLocation();

  const isSelectedRoute =
    location?.pathname === path ||
    (path !== "/" && location?.pathname?.startsWith(path));

  return (
    <ListItem
      sx={{ pl: leftSpace * 2 }}
      button
      component={Link}
      onClick={toggle}
      to={path}
      selected={isSelectedRoute}
      dense
    >
      <Badge
        badgeContent={badgeContent}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        color="secondary"
      >
        <ListItemIcon>{Icon && <Icon />}</ListItemIcon>
      </Badge>
      <ListItemText primary={label} />
    </ListItem>
  );
};
